import React from 'react';
import { createRoot } from 'react-dom/client';

document.addEventListener('DOMContentLoaded', () => {
  const blocks = document.querySelectorAll('.wp-block-vibemap-events-listing-native');
  blocks.forEach((block) => {
    const attributes = JSON.parse(block.getAttribute('data-attributes'));
    const root = createRoot(block);
    root.render(
      <div>Events Listing will appear here. {JSON.stringify(attributes)}</div>
    );
  });
});